import { render, staticRenderFns } from "./PartnerRequestsList.vue?vue&type=template&id=301c7a0c&"
import script from "./PartnerRequestsList.vue?vue&type=script&lang=js&"
export * from "./PartnerRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports